<template>
    <div>

        <div style="padding-bottom: 50px;">
            <card v-for="item in jt808devicesList">
                <Row>
                    <label style="color: #0077aa;">主机号：
                        <Button type="primary" @click="onJt808MonitoringViewModal(item)" size="small">{{item.terminalNum}}</Button>
                    </label>
                    <span class="distance fr" style="padding: 5px;">|</span>
                    <label style="color: #0077aa;">状态：{{item.state==2?'行驶':item.state==1?'熄火':item.state==3?'停车未熄火':'离线'}}</label>
                </Row>
                <Row>
                    <label>终端型号：{{item.terminalModel}}</label>
                </Row>
                <Row>
                    <label>固件版本：{{item.firmwareVersion}}</label>
                </Row>
                <Row>
                    <label>更新时间：{{new Date(item.lastRecvDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label>

                </Row>
                <Row>
                    <label>定位时间：{{new Date(item.lastLocateDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label>
                </Row>
                <Row>
                    <label>采集驾驶员：
                        <Input v-model=item.collectDriverName style="width: 60%" readonly size="small"></Input>
                    </label>
                </Row>
                <Row>
                    <label>采集驾驶证：
                        <Input v-model=item.collectDriverLicenseNum style="width: 60%" readonly size="small"></Input>
                    </label>
                </Row>
                <Row>
                    <label>实时驾驶员：
                        <Input v-model=item.driverName style="width: 60%" readonly size="small"></Input>
                    </label>
                </Row>
                <Row>
                    <label>
                        实时驾驶证：
                        <Input v-model=item.driverLicenseNum style="width: 60%" readonly size="small"></Input>
                    </label>
                </Row>
                <Row>
                    <label>司机卡更新时间：{{item.driverCardReportDatetime==null?'':new Date(item.driverCardReportDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label>
                </Row>
                <Row>
                    <Button style="position:absolute;right: 0px;bottom: 0px;" type="info" size="small"
                            @click="onupVehicleParamsModal(item)">写司机卡
                    </Button>
                </Row>
            </card>
        </div>

        <select-send-command-modal v-model="selectSendCommandModal" :initValue="selectSendCommandId" :installed="selectSendCommandTrationNum"></select-send-command-modal>
        <jt808-monitoring-view-modal ref="Jt808MonitoringViewModalRef" v-model="jt808MonitoringViewModal" :initValue="jt808MonitoringViewId" :jt808MonitoringViewterminalNum="jt808MonitoringViewterminalNum"></jt808-monitoring-view-modal>

    </div>
</template>
<script>

    import Vue from 'vue';
    import {mapActions} from 'vuex'
    import store from '@/store'
    import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"
    import SelectSendCommandModal from '@/views/ddm/components/select-send-command-modal'
    import Jt808MonitoringViewModal from '@/views/ddm/components/jt808-monitoring-view-modal'


    export default {
        name: 'jt808devicesforterminalnummodal',
        props: {
            value: {
                type: Boolean,
                default: false
            },
            initValue: null,
        },
        components: {
            SelectSendCommandModal,
            Jt808MonitoringViewModal,
        },
        data() {
            return {
                vehicleInfo: {
                    identificationCode: null
                },
                installOrder: {},


                /**
                 * 查询出来的jt808实时状态
                 */
                jt808devicesList: [],

                //选择写卡生产商
                selectSendCommandModal:false,
                selectSendCommandId:null,//JT808id
                selectSendCommandTrationNum:null,//主机号

                // 实时监控组件
                jt808MonitoringViewModal: false,
                jt808MonitoringViewId: null,
                jt808MonitoringViewterminalNum: null,
            }
        },
        methods: {
            jt808DevicesState() {
                this.jt808devicesList = []
                if (this._initValue != null && this._initValue.length > 0) {
                    this._initValue.forEach((item, index) => {
                        store.dispatch('Jt808DeviceServ_GetPage', {
                            params: null,
                            urlparams: {
                                q: genQueryParam("terminalNum", "EQ", item.terminalNum)
                            }
                        }).then(res => {
                            if (store.getters.get_Jt808Device_GetPageResult.content.length>0) {
                                this.jt808devicesList.push(store.getters.get_Jt808Device_GetPageResult.content[0])
                            }
                        }).catch(err => {
                            this.$Message.error(err)
                        })
                    })
                }
            },
            onupVehicleParamsModal(e){
                this.selectSendCommandId=e.id
                this.selectSendCommandModal=true
                this.selectSendCommandTrationNum = e.terminalNum
            },
            onJt808MonitoringViewModal(device){
                this.jt808MonitoringViewModal = true
                this.jt808MonitoringViewId = device.id
                this.jt808MonitoringViewterminalNum = device.terminalNum
            }
        },
        computed: {
            _value: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val)
                    this.$emit('change', val)
                }
            },
            _initValue: {
                get() {
                    return this.initValue
                },
                set(val) {
                    // this.$emit('input', val);
                    // this.$emit('change', val);
                }
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.jt808DevicesState()
                /**
                 * 每15秒刷新一次jt808实时状态
                 */
                setInterval(() => {
                    this.jt808DevicesState()
                }, 15000);

            })
        }
    }
</script>
<style>
    .demo-split {
        height: 500px;
        border: 1px solid #dcdee2;
    }

    .demo-split-pane {
        padding: 10px;
    }
</style>
